import type { OnboardingGoal, OnboardingLevel } from './onboarding'
import { PATH_VERSION } from './path-core'
import { supabase } from './supabase'

export type UserLearningPreferences = {
  user_id: string
  goal: OnboardingGoal | null
  level: OnboardingLevel | null
  start_node_id: string | null
  path_version: string
  created_at: string
  updated_at: string
}

export async function getUserLearningPreferences() {
  const { data, error } = await supabase
    .from('user_learning_preferences')
    .select('*')
    .maybeSingle()

  if (error) throw error
  return data as UserLearningPreferences | null
}

export async function upsertUserLearningPreferences(
  userId: string,
  input: Partial<
    Pick<UserLearningPreferences, 'goal' | 'level' | 'start_node_id'>
  >
) {
  const payload: {
    user_id: string
    path_version: string
    updated_at: string
    goal?: OnboardingGoal | null
    level?: OnboardingLevel | null
    start_node_id?: string | null
  } = {
    user_id: userId,
    path_version: PATH_VERSION,
    updated_at: new Date().toISOString()
  }

  if ('goal' in input) payload.goal = input.goal ?? null
  if ('level' in input) payload.level = input.level ?? null
  if ('start_node_id' in input) {
    payload.start_node_id = input.start_node_id ?? null
  }

  const { data, error } = await supabase
    .from('user_learning_preferences')
    .upsert(payload, { onConflict: 'user_id' })
    .select()
    .single()

  if (error) throw error
  return data as UserLearningPreferences
}
